import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  file: () => __(translations.imageInput.file, 'File'),
  select: () => __(translations.imageInput.select, 'Select…'),
};
